/**
 * BT-GSD-KARATE-MEMBERSHIP-PORTAL-001 — constantes d'adhésion.
 * Les politiques marquées TEMP-* restent configurables jusqu'à décision officielle.
 */

export const MEMBERSHIP_BT_ID = "BT-GSD-KARATE-MEMBERSHIP-PORTAL-001";

export const MEMBERSHIP_STORAGE_KEY = "karate-membership-portal-v1";

export const ROBOT_ORIGIN = "robot-membership-001";

export const SANDBOX_MEMBER_PASSWORD = "membre123";

export const MEMBERSHIP_STATUSES = Object.freeze({
  DRAFT: "draft",
  FORM_INCOMPLETE: "form_incomplete",
  HEALTH_PENDING: "health_pending",
  PAYMENT_PENDING: "payment_pending",
  PENDING_APPROVAL: "pending_approval",
  ACTIVE: "active",
  EXPIRED: "expired",
  SUSPENDED: "suspended",
  CANCELLED: "cancelled",
});

export const BLACK_DRAGON_STATUSES = Object.freeze({
  NOT_MEMBER: "not_member",
  REQUEST_SUBMITTED: "request_submitted",
  INVITED: "invited",
  PENDING_APPROVAL: "pending_approval",
  ACTIVE: "active",
  REFUSED: "refused",
  WITHDRAWN: "withdrawn",
});

export const BD_CONTENT_VISIBILITY = Object.freeze({
  PUBLIC: "public",
  SHOTOKAN_MEMBERS: "shotokan_members",
  BLACK_DRAGON: "black_dragon",
  ADMIN: "admin",
});

export const REGISTRATION_KIND = Object.freeze({
  ADULT: "adult",
  MINOR: "minor",
});

export const PAYMENT_METHODS = Object.freeze({
  CARD: "card",
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay",
  PAYPAL: "paypal",
  SANDBOX: "sandbox",
});

export const PAYMENT_STATUSES = Object.freeze({
  NONE: "none",
  PENDING: "pending",
  CONFIRMED: "confirmed",
  FAILED: "failed",
  REFUNDED: "refunded",
});

/** Montant initial officiel — ne pas dupliquer le 35 ailleurs. */
export const DEFAULT_ANNUAL_FEE_CENTS = 3500;

export const DEFAULT_CURRENCY = "CAD";

/** TEMP-POLICY: période civile jusqu'à politique de renouvellement officielle. */
export const TEMP_PERIOD_POLICY = "TEMP-POLICY-CALENDAR-YEAR";

/** TEMP-POLICY: Sensei ne voit pas la santé tant que la règle officielle n'est pas définie. */
export const TEMP_SENSEI_HEALTH_POLICY = "TEMP-POLICY-SENSEI-NO-HEALTH";

/** TEMP-POLICY: approbation Black Dragon = Hanshi / admin jusqu'à règle officielle. */
export const TEMP_BD_APPROVER_POLICY = "TEMP-POLICY-BD-APPROVER-HANSHI";

export const HEALTH_FORM_VERSION_ADULT = "TEMP-AAMC-ADULT-001";
export const HEALTH_FORM_VERSION_MINOR = "TEMP-AAMC-MINOR-001";

export const ACCESS_LEVEL = Object.freeze({
  PUBLIC: "public",
  MEMBER: "member",
  BLACK_DRAGON: "black_dragon",
});
